import React from 'react';

const Curriculum = () => {
  return (
    <div className="curriculum">
      <div className="container">
        <h1>Our Curriculum</h1>
        <p>Learn about our educational programs and curriculum designed for early childhood development.</p>
      </div>
    </div>
  );
};

export default Curriculum;